const api = {
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
};

export default api;
